import { PlainRangeInterface, RangeInterface } from './range.interface';

export abstract class RangeModel<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string | number,
  RangeType = unknown,
  StartType extends RangeType | null = StartBoundary extends 'finite'
    ? RangeType
    : RangeType | null,
  EndType extends RangeType | null = EndBoundary extends 'finite' ? RangeType : RangeType | null,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  Options extends object = never,
> {
  public readonly start: StartType;

  public readonly end: EndType;

  public readonly inclusiveStart: boolean = true;

  public readonly inclusiveEnd: boolean = false;

  /**
   * Either include or exclude the start from the range
   */
  public abstract min: StartType;

  /**
   * Either include or exclude the end from the range
   */
  public abstract max: EndType;

  constructor(
    start: StartType,
    end: EndType,
    inclusiveStart: boolean = true,
    inclusiveEnd: boolean = false,
  ) {
    this.start = start;
    this.end = end;
    this.inclusiveStart = inclusiveStart;
    this.inclusiveEnd = inclusiveEnd;
  }

  /**
   * returns true if target is within range
   */
  public abstract contains(target: RangeType): boolean;

  /**
   * return a plain object representation of the range.
   */
  public static fromObject(data: RangeInterface): RangeModel {
    throw new Error('implementation missing');
  }

  /**
   * return a plain object representation of the range.
   */
  // eslint-disable-next-line
  public abstract toObject(): PlainRangeInterface<any, any, any, any, any>;

  /**
   * Returns a human-readable string. Shortening the string if possible.
   * This is basically a shortcut for {@see this.format} prefilling it which human-readable parameters
   *
   * @param divider between the to RangeType. by default the dates are seperated by
   * a dash: ' - '.
   * @param formatString
   * @param options
   */
  public abstract humanReadableString(
    divider?: string,
    formatString?: string,
    options?: Options,
  ): string;

  /**
   * Formatting the Range using the appropriated format string notations and dividing it
   * with the given divider parameter string.
   *
   * @param formatString date-fns format string. Returns the default
   * {@see TsRange.humanReadableString} if empty.
   * @param divider between the to dates. by default the dates are seperated by
   * a dash: ' - '.
   */
  public abstract format(formatString: string, divider?: string): string;

  /**
   * return a string representation of the range. Postgres compatible notation
   */
  public abstract toString(): string;
}
